import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/molecules/CategoriesList.css'
import { CategoryId } from 'interfaces/meta'
import { IS_MOBILE } from 'helpers/userAgentHelpers'

export type CategoryItem = {
  id: CategoryId
  categoryName: string
  value: string
  // TODO refactor to use moneyflow => style mapping
  color?: string
  isSelected: boolean
  isShaded: boolean
}

export type CategoriesListProps = {
  items: CategoryItem[]
  fontColor: string
  onHoverItem: (id: CategoryId | null) => void
  onClickItem?: (id: CategoryId | null) => void
}

const CategoriesList: StatelessComponent<CategoriesListProps> =
  ({ items, fontColor, onClickItem, onHoverItem }: CategoriesListProps) => (
    <ul className={ styles.categoriesList } style={{ color: fontColor }} data-qa-marker='categories-list'>
      { items.map(({ id, categoryName, value, color, isShaded, isSelected }) => {
        const className = cn(styles.item, { [styles.shaded]: isShaded })
        const handleClick = onClickItem ? () => onClickItem(isSelected ? null : id) : undefined
        const handleMouseEnter = isSelected || IS_MOBILE ? undefined : () => onHoverItem(id)
        const handleMouseLeave = isSelected || IS_MOBILE ? undefined : () => onHoverItem(null)
        const title = `${ categoryName }…${ value }`

        return (
          <li
            key={ id }
            className={ className }
            onMouseEnter={ handleMouseEnter }
            onMouseLeave={ handleMouseLeave }
            onClick={ handleClick }
          >
            <span className={ styles.itemPoint } style={{ backgroundColor: color }} />
            <span className={ styles.itemText } data-qa-marker={ title.toLowerCase() }>
              { title }
            </span>
          </li>
        )
      }) }
    </ul>
  )

export default CategoriesList
